import { HttpErrorResponse, HttpHandler, HttpInterceptorFn } from '@angular/common/http';
import { catchError, take, throwError } from "rxjs";


export const networkErrorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = '';

      if (error.status === 0) {
        // A client-side or network error occurred.
        errorMessage = `(Network) Please check your internet connection or contact support.`;
        console.error('An error occurred:', error?.error);
        return throwError(() => new Error(errorMessage));
      } else {
        return next(req);
      }
    })
  );
};
